import { connect, useDispatch } from "react-redux";
import TrainingHelpEdit from "./trainingHelpEdit";
import { useState, useEffect } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  getTrainingHelps,
  getTrainingHelp,
  deleteTrainingHelp,
} from "../../../../../action/masters/trainingHelpActionCreator";
import { baseURL } from "../../../../../constants/commonConstants";
import {
  alertConstants,
  getAlertData,
} from "../../../../../helper/sweet-alert";
import {
  ITrainingHelpIndex,
  ITrainingHelps,
} from "../../../../../models/master/trainingHelp";
import { setTrainingHelps } from "../../../../../store/slices/master/trainingHelpSlice";
import TrainingHelpCreate from "./trainingHelpCreate";
import ReactModal from "react-modal";
import LoaderSpinner from "../../../../../common-components/loader";

const TrainingHelpIndex = (props: ITrainingHelpIndex) => {
  const {
    getTrainingHelp,
    getTrainingHelps,
    trainingHelp,
    trainingHelps,
    deleteTrainingHelp,
  } = props;
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<number>(0);
  const [errors, setErrors] = useState<any>(undefined);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isEditLoading, setIsEditLoading] = useState<boolean>(false);

  const handleCreateOpen = () => setShowCreate(true);
  const handleCreateClose = () => setShowCreate(false);
  const handleEditOpen = () => setShowEdit(true);
  const handleEditClose = () => setShowEdit(false);

  const dispatch = useDispatch();

  const editItem = async (id: number) => {
    setShowEdit(true);
    setIsEditLoading(true);
    try {
      await getTrainingHelp(id);
    } finally {
      setIsEditLoading(false);
    }
  };

  const deleteItem = (id: number) => {
    setIsDelete(true);
    setAlert(alertConstants.inactiveCheck);
    setItemToDelete(id);
  };

  const onConfirm = () => {
    if (alertType === alertConstants.error) {
      setShowAlert(false);
    } else if (isDelete === true) {
      setShowAlert(false);
      setIsDelete(false);
      deleteTrainingHelp(itemToDelete, setAlert);
    } else {
      setShowAlert(false);
      setIsDelete(false);
      getAllTrainingHelps();
    }
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const getAllTrainingHelps = async () => {
    setIsLoading(true);
    try {
      await getTrainingHelps();
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAllTrainingHelps();
    return () => {
      dispatch(setTrainingHelps([]));
    };
  }, []);

  return (
    <>
      <div className="admincontent">
        <div className="title">
          <h2>Training Help</h2>
          <a
            href="javascript:void(0)"
            className="btn btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#addnewbuttons"
            onClick={() => {
              setShowCreate(true);
            }}
          >
            <img src="/assets/images/icon/plus.svg" alt="" className="me-2" />
            Add New
          </a>
        </div>
        <ul className="d-flex grid-3 gap-3 flex-wrap mt-28">
          {isLoading ? (
            <LoaderSpinner />
          ) : trainingHelps && trainingHelps.length > 0 ? (
            trainingHelps.length > 0 &&
            trainingHelps.map((trainingHelp: ITrainingHelps) => {
              return (
                <li
                  className="admin-card"
                  style={{
                    pointerEvents: !trainingHelp.isActive ? "none" : "auto",
                    opacity: !trainingHelp.isActive ? 0.5 : 1,
                  }}
                >
                  <div className="top">
                    <div className="btn-flex">
                      <button
                        className="btn-edit"
                        onClick={() => editItem(trainingHelp.id ?? 0)}
                      >
                        <img src="/assets/images/icon/edit-wh.svg" alt="" />
                      </button>
                      <button
                        className="btn-delete"
                        onClick={() => deleteItem(trainingHelp.id ?? 0)}
                      >
                        <img src="/assets/images/icon/trash-wh.svg" alt="" />
                      </button>
                    </div>
                  </div>
                  <a href={trainingHelp.videoLink} target="_blank">
                    <div className="btm">
                      <div className="img">
                        <img
                          alt=""
                          src={
                            trainingHelp.image
                              ? baseURL + trainingHelp.image
                              : ""
                          }
                        />
                      </div>
                      <h2>{trainingHelp.name}</h2>
                    </div>
                  </a>
                </li>
              );
            })
          ) : (
            <p>No Records Found</p>
          )}
        </ul>
      </div>

      <ReactModal
        isOpen={showCreate}
        onRequestClose={handleCreateClose}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
        shouldCloseOnOverlayClick={false}
      >
        <TrainingHelpCreate
          setShowCreate={handleCreateClose}
          getAllTrainingHelps={() => getAllTrainingHelps()}
        />
      </ReactModal>
      {isEditLoading ? (
        <LoaderSpinner />
      ) : (
        <ReactModal
          isOpen={showEdit}
          onRequestClose={handleEditClose}
          className="react-modal-content"
          overlayClassName="react-modal-overlay"
          shouldCloseOnOverlayClick={false}
        >
          <TrainingHelpEdit
            trainingHelp={trainingHelp}
            setShowEdit={handleEditClose}
            getAllTrainingHelps={() => getAllTrainingHelps()}
          />
        </ReactModal>
      )}
      <SweetAlert
        show={showAlert}
        success={false}
        type={alertType}
        title={alertTitle}
        onConfirm={() => onConfirm()}
        showCancel={isDelete}
        onCancel={() => {
          setShowAlert(false);
          setIsDelete(false);
        }}
        cancelBtnText={"No"}
        confirmBtnText={isDelete ? "Yes" : "Ok"}
      />
    </>
  );
};

const mapDispatchToProps = {
  getTrainingHelps: (
    pageBlockId?: number,
    noOfItems?: number,
    configUserType?: number
  ) => getTrainingHelps(pageBlockId, noOfItems, configUserType),
  getTrainingHelp: (id: number) => getTrainingHelp(id),
  deleteTrainingHelp: (id: number, callBack: Function) =>
    deleteTrainingHelp(id, callBack),
};

function mapStateToProps(state: any) {
  return {
    trainingHelps: state.trainingHelp?.trainingHelps,
    trainingHelp: state.trainingHelp?.trainingHelp,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TrainingHelpIndex);
